<template>
	<app-page>
		<div class="main-title">
			关于企业研究开发费用税前加计扣除政策有关问题的公告
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p style="text-align:center;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#999999"
									>国家税务总局公告2015年第97号</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>根据《中华人民共和国企业所得税法》及其实施条例（以下简称税法）、《财政部
									国家税务总局
									科技部关于完善研究开发费用税前加计扣除政策的通知》（财税〔2015〕119号，以下简称《通知》）规定，现就落实完善研究开发费用（以下简称研发费用）税前加计扣除政策有关问题公告如下：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 一、研究开发人员范围</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业直接从事研发活动人员包括研究人员、技术人员、辅助人员。研究人员是指主要从事研究开发项目的专业人员；技术人员是指具有工程技术、自然科学和生命科学中一个或一个以上领域的技术知识和经验，在研究人员指导下参与研发工作的人员；辅助人员是指参与研究开发活动的技工。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>企业外聘研发人员是指与本企业签订劳务用工协议（合同）和临时聘用的研究人员、技术人员、辅助人员。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 二、研发费用归集</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）加速折旧费用的归集</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业用于研发活动的仪器、设备，符合税法规定且选择加速折旧优惠政策的，在享受研发费用税前加计扣除时，就已经进行会计处理计算的折旧、费用的部分加计扣除，但不得超过按税法规定计算的金额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）多用途对象费用的归集</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业从事研发活动的人员和用于研发活动的仪器、设备、无形资产，同时从事或用于非研发活动的，应对其人员活动及仪器设备、无形资产使用情况做必要记录，并将其实际发生的相关费用按实际工时占比等合理方法在研发费用和生产经营费用间分配，未分配的不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）其他相关费用的归集与限额计算</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业在一个纳税年度内进行多项研发活动的，应按照不同研发项目分别归集可加计扣除的研发费用。在计算每个项目其他相关费用的限额时应当按照以下公式计算：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									其他相关费用限额＝《通知》第一条第一项允许加计扣除的研发费用中的第1项至第5项的费用之和×10％/(1-10%)。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									当其他相关费用实际发生数小于限额时，按实际发生数计算税前加计扣除数额；当其他相关费用实际发生数大于限额时，按限额计算税前加计扣除数额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> （四）特殊收入的扣减</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业在计算加计扣除的研发费用时，应扣减已按《通知》规定归集计入研发费用，但在当期取得的研发过程中形成的下脚料、残次品、中间试制品等特殊收入；不足扣减的，允许加计扣除的研发费用按零计算。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业研发活动直接形成产品或作为组成部分形成的产品对外销售的，研发费用中对应的材料费用不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）财政性资金的处理</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业取得作为不征税收入处理的财政性资金用于研发活动所形成的费用或无形资产，不得计算加计扣除或摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）不允许加计扣除的费用</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									法律、行政法规和国务院财税主管部门规定不允许企业所得税前扣除的费用和支出项目不得计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									已计入无形资产但不属于《通知》中允许加计扣除研发费用范围的，企业摊销时不得计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 三、委托研发</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业委托外部机构或个人开展研发活动发生的费用，可按规定税前扣除；加计扣除时按照研发活动发生费用的80%作为加计扣除基数。委托个人研发的，应凭个人出具的发票等合法有效凭证在税前加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业委托境外研发所发生的费用不得加计扣除，其中受托研发的境外机构是指依照外国和地区（含港澳台）法律成立的企业和其他取得收入的组织。受托研发的境外个人是指外籍（含港澳台）个人。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									四、不适用加计扣除政策行业的判定</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									《通知》中不适用税前加计扣除政策行业的企业，是指以《通知》所列行业业务为主营业务，其研发费用发生当年的主营业务收入占企业按税法第六条规定计算的收入总额减除不征税收入和投资收益的余额50%（不含）以上的企业。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 五、核算要求</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应按照国家财务会计制度要求，对研发支出进行会计处理。研发项目立项时应设置研发支出辅助账，由企业留存备查；年末汇总分析填报研发支出辅助账汇总表，并在报送《年度财务会计报告》的同时随附注一并报送主管税务机关。研发支出辅助账、研发支出辅助账汇总表可参照本公告所附样式（见附件）编制。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 六、申报及备案管理</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）
									企业年度纳税申报时，根据研发支出辅助账汇总表填报研发项目可加计扣除研发费用情况归集表（见附件），在年度纳税申报时随申报表一并报送。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二） 研发费用加计扣除实行备案管理，
									除“备案资料”和“主要留存备查资料”
									按照本公告规定执行外，其他备案管理要求按照《国家税务总局关于发布〈企业所得税优惠政策事项办理办法〉的公告》（国家税务总局公告2015年第76号）的规定执行。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）
									企业应当不迟于年度汇算清缴纳税申报时，向税务机关报送《企业所得税优惠事项备案表》和研发项目文件完成备案，并将下列资料留存备查：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.自主、委托、合作研究开发项目计划书和企业有权部门关于自主、委托、合作研究开发项目立项的决议文件；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.自主、委托、合作研究开发专门机构或项目组的编制情况和研发人员名单；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									3.经科技行政主管部门登记的委托、合作研究开发项目的合同；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									4.从事研发活动的人员和用于研发活动的仪器、设备、无形资产的费用分配说明（包括工作使用情况记录）；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									5.集中研发项目研发费决算表、集中研发项目费用分摊明细情况表和实际分享收益比例等资料；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 6.“研发支出”辅助账；</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									7.企业如果已取得地市级（含）以上科技行政主管部门出具的鉴定意见，应作为资料留存备查;</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									8.省税务机关规定的其他资料。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 七、后续管理与核查</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									税务机关应加强对享受研发费用加计扣除优惠企业的后续管理和监督检查。每年汇算清缴期结束后应开展核查，核查面不得低于享受该优惠企业户数的20%。省级税务机关可根据实际情况制订具体核查办法或工作措施。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 八、执行时间 </span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									本公告适用于2016年度及以后年度企业所得税汇算清缴。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 特此公告。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p></p>
				<p></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">国家税务总局</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">2015年12月29日</span></span
							></span
						></span
					>
				</p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>